import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';
import { SelectFieldResult } from '@wdx/clmi/clmi-swagger-gen';

@Injectable()
export class OrganisationClientTypesService {
    constructor(
        private http: HttpClient,
        private config: ConfigService,
    ) {}

    getAll(): Observable<SelectFieldResult[]> {
        return this.http.get<SelectFieldResult[]>(
            `${
                this.config.getConfiguration().API_BASE
            }/select/organisationclienttype`,
        );
    }
}
